export default "__VITE_ASSET__CEF0ohEi__"